// @flow

// Minimum viewport width (in dp/px) that triggers a "desktop" layout.
// Used across all screens that need to switch between mobile and desktop UX.
// Adjust this single value to update the breakpoint everywhere.
export const DESKTOP_BREAKPOINT = 640;
